import { render, staticRenderFns } from "./AppSendNotify.vue?vue&type=template&id=27f7ce6f&scoped=true"
import script from "./AppSendNotify.vue?vue&type=script&lang=js"
export * from "./AppSendNotify.vue?vue&type=script&lang=js"
import style0 from "./AppSendNotify.vue?vue&type=style&index=0&id=27f7ce6f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7ce6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f7ce6f')) {
      api.createRecord('27f7ce6f', component.options)
    } else {
      api.reload('27f7ce6f', component.options)
    }
    module.hot.accept("./AppSendNotify.vue?vue&type=template&id=27f7ce6f&scoped=true", function () {
      api.rerender('27f7ce6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/AppSendNotify.vue"
export default component.exports